import React from "react";
import { Box, Typography, Grid, Container } from "@mui/material";
import "./connectedsection.scss";

const ConnectedSection = () => {
  return (
    <div style={{ background: "#ECEBFD" }}>
      <Container>
        <Box className="auto-container">
          
          {/* Header Section */}
          <Box className="auto-header">
            <div className="auto-header-row">
              <Box className="auto-number">5</Box>
              <Typography className="auto-title">
              Connected Ecosystems with <span>API-Led Integration</span>
              </Typography>
            </div>

            <Typography className="auto-subtitle">
              The Future Of Financial Services Lies in Connected Ecosystems Powered By APIs. 
            </Typography>

           
          </Box>

          {/* Content Section */}
          <Grid container spacing={4} className="auto-content">
            
            {/* Left Image */}
            <Grid item xs={12} md={6} className="auto-image-wrapper">
              <Box className="auto-image-box">
                <img src="/images/trans.webp" alt="compliance illustration" />
              </Box>
            </Grid>

            {/* Right List */}
            <Grid item xs={12} md={6}>
              <ul className="auto-list">
                <Typography className="dd">Using MuleSoft, BFSI organizations can: </Typography>
                <li>Integrate core banking systems with modern applications  </li>
                <li>Enable real-time data exchange  </li>
                <li>Build scalable, API-first architectures  </li>
                <li>Participate in embedded finance ecosystems </li>
              </ul>
            </Grid>
          </Grid>

          {/* Bottom Cards */}
          <Grid container spacing={3} className="auto-bottom">
            <Grid item xs={12} md={6}>
              <Typography className="auto-card-title">UTIL Insight</Typography>
              <Box className="auto-card">
                <Typography>
                  <span>API-led connectivity</span> is key to financial services innovation.
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography className="auto-card-title">Business Impact</Typography>
              <Box className="auto-card">
                <Typography>
                  Banks evolve into
                  <span>  platform-driven ecosystem</span>
                   players.
                </Typography>
              </Box>
            </Grid>
          </Grid>

        </Box>
      </Container>
    </div>
  );
};

export default ConnectedSection;